export default __webpack_public_path__ + "images/EW.3dbee60.png";